import { client } from '@api/client';

import { normalizeObject } from '@utils/common';
import { IGetAssetFiltersDtoReturnType } from '@utils/getAssetTypesDtoForFilter';

import { IAssetsFilterThresholds } from '@interfaces/alarms/threshold';
import { TAsset } from '@interfaces/assets/asset';
import { TEmptyObject } from '@interfaces/common/common';
import { IIdDataDTO } from '@interfaces/common/defaultDTO';
import { IItemsResponse } from '@interfaces/common/response';
import { IGetAssetsDTO } from '@interfaces/map/dto/mapDTO';
import { ICustomPolygonDTO } from '@interfaces/map/dto/polygonDTO';
import { IPolygonDTO, IPolygonSummaryReturnType, TBoroughs } from '@interfaces/map/polygon';

import { URL } from './urls';

const {
	addCustomPolygon,
	assetManagement,
	assetsFilter,
	boroughs,
	checkPolygonName: checkName,
	deleteCustomPolygons,
	filterThresholds,
	polygonsFiltered,
	polygonsSummary,
	startupPolygon,
	updateCustomPolygon,
} = URL;

export const getAssets = (dto: Partial<IGetAssetsDTO>): Promise<IItemsResponse<TAsset>> => {
	return client.post(`/${assetsFilter}`, normalizeObject(dto));
};

export const getAssetById = (id?: string) => client.get(`/${assetManagement}/${id}`);

export const getBoroughs = (): Promise<TBoroughs> => client.get(`/${boroughs}`);

export const getFilterThresholds = (): Promise<IAssetsFilterThresholds | TEmptyObject> => {
	return client.post(`/${filterThresholds}`);
};

export const createCustomPolygon = (dto: ICustomPolygonDTO): Promise<void> => client.post(`/${addCustomPolygon}`, dto);

export const getCustomPolygons = (): Promise<IPolygonDTO> => client.get(`/${polygonsFiltered}`);

export const getPolygonsSummary = (dto: IGetAssetFiltersDtoReturnType): Promise<IPolygonSummaryReturnType> => {
	return client.post(`/${polygonsSummary}`, dto);
};

export const deletePolygons = (ids: string[]): Promise<void> => client.post(`/${deleteCustomPolygons}`, { ids });

export const checkPolygonName = (name: string): Promise<boolean> => client.post(`/${checkName}`, { name });

export const updatePolygon = ({ id, data }: IIdDataDTO<ICustomPolygonDTO>) =>
	client.post(`/${updateCustomPolygon}/${id}`, data);

export const getStartupPolygon = (): Promise<void> => {
	return client.get(`/${startupPolygon}`);
};
